import type { LigneMouvement, Mouvement } from '@mairistem/comptabilite';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class InformationsRattachementPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.INFORMATIONS_RATTACHEMENT;
		this.defaultSize = 6;
		this.icon = { name: 'linkify' };
	}

	getLibelle = () => 'Informations de rattachement';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.exerRattachement) &&
		!data?.lignes?.find((ligne) => ligne?.idLigneOriginePes) &&
		!data?.lignes?.find((ligne) => ligne?.naturePieceOrigine) &&
		!data?.lignes?.find((ligne) => ligne?.pieceOrigine);

	/**
	 * Cas par défaut (saisie libre) : les 4 champs de rattachement sont requis.
	 * Les blocs précis surchargent `isComplete` via `isCompleteFor` pour ne
	 * contrôler que les champs effectivement saisis dans leur composant.
	 */
	isComplete = (data: Mouvement) =>
		this.isCompleteFor(
			data,
			'exerRattachement',
			'idLigneOriginePes',
			'naturePieceOrigine',
			'pieceOrigine',
		);

	/**
	 * Le bloc est complet quand chaque ligne renseigne tous les `champs` passés.
	 * @param data Le mouvement en cours de saisie
	 * @param champs Les champs de la ligne effectivement requis par le bloc
	 */
	protected isCompleteFor = (
		data: Mouvement,
		...champs: Array<keyof LigneMouvement>
	): boolean => this.everyLigneHas(data, ...champs);
}

export default InformationsRattachementPanel;
